@if (errorMessage) {
  <tidy-error-message
    [text]="errorMessage" />
}

@if (windowService.isDesktopRes) {
  <tidy-desktop-header>
    <div class="wrappable-container allow-wrap">
      <tidy-text
        [title]="'Deposits'" />
      <tidy-text
        [helper]="'Security deposits, pet deposits, and damage claims by reservation. The deposit agent runs on check-out to initiate refunds or flag claims.'" />
    </div>
    <div class="non-wrappable-right-aligned-container">
      <automations-preview-button
        [tag]="'deposits'" />
    </div>
  </tidy-desktop-header>
  <!-- Skeleton table while loading — rows float in with the entrance cascade;
       the real table below then replaces it in place, instantly (skipEntrance). -->
  @if (!isDataLoaded) {
    <tidy-table
      [skeletonLoading]="true"
      [columnslabels]="headers" />
  }
  @if (isDataLoaded && rows.length > 0) {
    <div class="desktop-flex-fill">
      <tidy-table
        #tidyTable
        [dataSource]="rows"
        [displayedColumns]="headers"
        [columnslabels]="headers"
        [allRowIsClickable]="true"
        [rowsToShow]="25"
        [showColumnLines]="false"
        [skipEntrance]="true"
        (sortChange)="sortChanged($event)"
        (cellClick)="onTableColumnClick($event)"
        [blockSorting]="true" />
    </div>
  }
  @if (isDataLoaded && rows.length === 0) {
    <tidy-alert>
      <tidy-row>
        <tidy-text [body]="getEmptyStateMessage()" />
      </tidy-row>
    </tidy-alert>
  }
}

@if (!windowService.isDesktopRes) {
  @if (!isDataLoaded) {
    <div style="width: 100%">
      <ion-skeleton-text
        animated="true"
        style="height: 75px; border-radius: 6px" />
    </div>
    <div style="width: 100%; padding-top: 1rem;">
      <ion-skeleton-text
        animated="true"
        style="height: 200px; border-radius: 6px" />
    </div>
  }
  @if (isDataLoaded) {
    @for (deposit of deposits; track deposit.id) {
      <tidy-card>
        <tidy-row [alignLastItemRight]="true">
          <tidy-text
            [header]="deposit.property_name || 'Unknown Property'"
            [translate]="false" />
          <tidy-text
            [helper]="deposit.status"
            [translate]="false" />
        </tidy-row>
        <tidy-row class="extra-top-padding">
          <tidy-text
            [body]="deposit.guest_name + ' — ' + deposit.reservation_dates"
            [translate]="false" />
        </tidy-row>
        <tidy-row class="extra-top-padding">
          <tidy-grid>
            <ion-row>
              <ion-col size="4">
                <tidy-row>
                  <tidy-text [helper]="'Type'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="deposit.deposit_type"
                    [translate]="false" />
                </tidy-row>
              </ion-col>
              <ion-col size="4">
                <tidy-row>
                  <tidy-text [helper]="'Amount'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="'$' + deposit.amount?.toLocaleString('en-US')"
                    [translate]="false" />
                </tidy-row>
              </ion-col>
              <ion-col size="4">
                <tidy-row>
                  <tidy-text [helper]="'Channel'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="deposit.channel"
                    [translate]="false" />
                </tidy-row>
              </ion-col>
            </ion-row>
          </tidy-grid>
        </tidy-row>
        @if (deposit.claim_amount > 0) {
          <tidy-row class="extra-top-padding">
            <tidy-text
              [helper]="'Claim: $' + deposit.claim_amount?.toLocaleString('en-US') + ' — ' + deposit.claim_reason"
              [translate]="false" />
          </tidy-row>
        }
      </tidy-card>
    }
    @if (deposits.length === 0) {
      <tidy-alert>
        <tidy-row>
          <tidy-text [body]="getEmptyStateMessage()" />
        </tidy-row>
      </tidy-alert>
    }
  }
}
